import { render, staticRenderFns } from "./b-menu-main-bubble.vue?vue&type=template&id=ca085a96&scoped=true&"
import script from "./b-menu-main-bubble.vue?vue&type=script&lang=js&"
export * from "./b-menu-main-bubble.vue?vue&type=script&lang=js&"
import style0 from "./b-menu-main-bubble.vue?vue&type=style&index=0&id=ca085a96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca085a96",
  null
  
)

export default component.exports